// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3kBcK","insightsList":"newBusinessInsightsMenu_insightsList__IBYUX","active":"newBusinessInsightsMenu_active__IeOxg"};